// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "aprovacaoagil-e28d2.firebaseapp.com",
  "projectId": "aprovacaoagil-e28d2",
  "storageBucket": "aprovacaoagil-e28d2.appspot.com",
  "messagingSenderId": "934101532984",
  "appId": "1:934101532984:web:ad4afb8988d0397a23c1cd",
  "measurementId": "G-XBGKZKP2E5",
  "apiKey": "AIzaSyArd1dLRAEP86Ic0Ned-ikujz05TUznIj0"
};
